import { isEmpty } from 'lodash-es';

export const isEmptyMarkdownBody = (body?: string | null): body is undefined | null =>
  isEmpty(body) || body === '<p></p>';
